import {icons} from "@/ui/icons"

export const staffSubmenuOptions = <const>[
  {
    name: "Reports",
    url: "reporting",
    icon: icons.imBarChart4,
    admin: false,
    super: false,
  },
  {
    name: "PCR Templates",
    url: "pcrTemplates",
    icon: icons.imFileEdit,
    admin: true,
    super: false,
  },
  {
    name: "Microsite Documents",
    url: "micrositeDocuments",
    icon: icons.imFiles,
    admin: false,
    super: false,
  },
  {
    name: "Fee Comparison",
    url: "feeComparison",
    icon: icons.imCoins,
    admin: false,
    super: false,
  },
  {
    name: "Insurance Calculation",
    url: "insuranceCalculation",
    icon: icons.imGrave,
    admin: false,
    super: false,
  },
  {
    name: "Insurance Statements",
    url: "insuranceStatements",
    icon: icons.imLifeSafer,
    admin: true,
    super: false,
  },
  {
    name: "Member Events",
    url: "memberEvents",
    icon: icons.imBusinessManWoman,
    admin: false,
    super: false,
  },
  {
    name: "Investment Options",
    url: "investmentOptions",
    icon: icons.imFinancial,
    admin: true,
    super: false,
  },
  {
    name: "Import/Export",
    url: "importExport",
    icon: icons.imUpload1,
    admin: true,
    super: false,
  },
  {
    name: "Salesforce Exports",
    url: "salesforceExports",
    icon: icons.imDataCloud,
    admin: true,
    super: false,
  },
  /* {
    name: "Dev Ops",
    url: "devOps",
    icon: icons.imEngineering,
    admin: true,
  },*/
  {
    name: "OneCentral Activity",
    url: "onecentralActivity",
    icon: icons.imUser,
    admin: true,
    super: false,
  },
  {
    name: "OneCentral Imports",
    url: "onecentralImports",
    icon: icons.imUpload,
    admin: true,
    super: false,
  },
  {
    name: "Security",
    url: "security",
    icon: icons.imSecuritySettings,
    admin: false,
    super: true,
  },
]
